






























import {
  computed,
  defineComponent,
  useContext,
  ref,
  onMounted,
} from '@nuxtjs/composition-api'
import { useLoading } from '~/composables/ui/useLoading'

const renderOptions = {
  renderContainer: '.render-form',
}

export default defineComponent({
  name: 'BlocksDynamicForm',

  inheritAttrs: false,

  props: {
    content: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => {},
    },
  },

  setup(props) {
    const { app } = useContext()
    const formId = computed(() => props.data?.FormID)
    const formEl = ref<HTMLFormElement | null>(null)
    const submitText = ref('')
    const title = ref('')

    const getFormLoading = useLoading()
    const getForm = () => {
      return getFormLoading.scope(async () => {
        const result = await app.$api.form.getForm(formId.value)
        if (result) {
          submitText.value = result.submitText || 'Submit'
          title.value = result.title
          renderForm(result.data)
        }
      })
    }

    const renderForm = (formData: string) => {
      if (formData) {
        const { FormeoRenderer } = require('formeo')
        const renderer = new FormeoRenderer(renderOptions)
        renderer.render(JSON.parse(formData))
      }
    }

    onMounted(async () => {
      await getForm()
    })

    const creatSubmitFormJson = (form: HTMLFormElement) => {
      const result: string[] = []

      for (let i = 0; i < form.elements.length; i++) {
        const e = form.elements[i] as HTMLFormElement
        let newElement: any = null
        if (e.type === 'radio') {
          if (e.checked === true) {
            newElement = { Name: '', Label: '', Value: '', Type: '', ID: '' }
            const labelElement = e.parentElement?.parentElement?.parentElement
              ?.firstChild as HTMLElement
            const labelText = labelElement.innerHTML
            if (labelText !== undefined) {
              newElement.Label = labelText
            }
            newElement.Value = encodeURIComponent(e.value)
            newElement.Type = e.type
            newElement.Name = e.name
            newElement.ID = e.id
          }
        } else if (e.type === 'checkbox') {
          if (e.checked === true) {
            newElement = { Name: '', Label: '', Value: '', Type: '', ID: '' }
            const labelElement = e.parentElement?.parentElement?.parentElement
              ?.firstChild as HTMLElement
            const labelText = labelElement.innerHTML
            if (labelText !== undefined) {
              newElement.Label = labelText
            }
            newElement.Value = encodeURIComponent(e.value)
            newElement.Type = e.type
            newElement.Name = e.name
            newElement.ID = e.id
          }
        } else {
          newElement = { Name: '', Label: '', Value: '', Type: '', ID: '' }
          newElement.Type = e.type
          newElement.Name = e.name
          newElement.ID = e.id
          newElement.Value = encodeURIComponent(e.value)
          if (e.labels.length > 0) {
            newElement.Label = e.labels[0].innerText
          }
        }
        if (newElement != null) {
          result.push(newElement)
        }
      }

      return JSON.stringify(result)
    }

    const submitLoading = useLoading()
    const onSubmit = (e: Event) => {
      e.preventDefault()
      return submitLoading.scope(async () => {
        if (formEl.value) {
          const formData: any = new FormData(formEl.value)
          const formDataString = new URLSearchParams(formData).toString()
          const formJson = creatSubmitFormJson(formEl.value)

          const response = await app.$api.form.submitForm(
            formId.value,
            title.value,
            formDataString,
            formJson
          )
          if (response && response.successUrl) {
            window.location.href = response.successUrl
          }
        }
      })
    }

    return {
      formEl,
      submitText,

      getFormLoading: getFormLoading.value,
      submitLoading: submitLoading.value,

      onSubmit,
    }
  },

  head: {
    link: [
      {
        rel: 'stylesheet',
        href: 'https://cdn.jsdelivr.net/npm/formeo@1.6.2/dist/formeo.min.css',
      },
    ],
    script: [
      {
        src: 'https://www.google.com/recaptcha/api.js',
        async: true,
        defer: true,
      },
    ],
  },
})
